import type {BuildTypeId, ProjectId} from '../../../types'
import type {ProjectsTreeItem} from '../../../types/projectTrees'

export const MAX_ITEMS_TO_EXPAND = 500
export const EXPAND_ITEMS_PER_MOMENT = 40

export enum CollapseButtonEnum {
  EXPAND_ALL = 'Expand All',
  COLLAPSE_ALL = 'Collapse All',
  LOADING = 'Loading',
}

export function groupIdsByEntityType(entities: Array<ProjectsTreeItem>) {
  return entities.reduce(
    (acc, entity) => {
      if (entity.itemType === 'buildType' && entity.id != null) {
        acc.buildTypeIds.push(entity.id)
      }

      if (entity.itemType === 'project') {
        acc.projectIds.push(entity.id)
      }

      return acc
    },
    {buildTypeIds: [] as Array<BuildTypeId>, projectIds: [] as Array<ProjectId>},
  )
}
